import { render } from "./component-reg-date.vue?vue&type=template&id=44b96f74"
import script from "./component-reg-date.vue?vue&type=script&setup=true&lang=js"
export * from "./component-reg-date.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/contract-card/components/component-reg-date.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "44b96f74"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('44b96f74', __exports__)) {
    api.reload('44b96f74', __exports__)
  }
  
  module.hot.accept("./component-reg-date.vue?vue&type=template&id=44b96f74", () => {
    api.rerender('44b96f74', render)
  })

}


export default __exports__